import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import useInputs from '../../../../utils/hooks/useInputs'
import FuelStationComparisionItem from '../../../../components/fuel-stations/fuel-stations-own/FuelStationComparisionItem'
import { FavoritesFuelStationsService } from '../../../../services/favorites-fuel-stations/favoritesFuelStations.service'
import useEditByLocation from '../../../../utils/hooks/useEditByLocation'
import useAccess from '../../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../../utils/constants/roles'
import { OwnFuelStationsService } from '../../../../services/own-fuel-stations/ownFuelStations.service'
import MainCommonView from '../../../../components/common/MainCommonView'

const OwnFuelStationCompetencies = () => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const { isEdit, enableEdit } = useEditByLocation()
  const { canEdit } = useAccess()
  const { inputs, onChangeInputs, updateInputs } = useInputs()
  const [favoriteStations, setFavoriteStations] = useState([])

  useEffect(() => {
    getOwnFuelStationData()
  }, [])

  const getOwnFuelStationData = async () => {
    const resp = await OwnFuelStationsService.getById(id)
    if (resp) {
      updateInputs({ comparisons: resp?.resp?.comparisons })
      getFuelStationFavorite(
        resp?.resp.locality?.toLowerCase(),
        resp?.resp?.comparisons,
      )
    }
  }

  const getFuelStationFavorite = async (ownStationProvince, comparisions) => {
    const favoriteStationIds = Object.values(comparisions)
      .filter((comparison) => comparison.favoriteStation)
      .map((comparison) => comparison.favoriteStation._id)

    const resp = await FavoritesFuelStationsService.getAll({})
    if (resp) {
      const fuelStationsLocality = resp?.resp.filter(
        (x) =>
          x?.addressInfo?.locality?.toLowerCase() === ownStationProvince ||
          favoriteStationIds?.includes(x?._id),
      )
      setFavoriteStations(fuelStationsLocality)
    }
  }

  const handleUpdate = async () => {
    const data = Object.fromEntries(
      Object.keys(inputs?.comparisons)
        .map((comp) => {
          const differenceValue = inputs?.comparisons[comp]?.difference
          if (!Number.isNaN(differenceValue) && differenceValue !== '') {
            return [
              comp,
              {
                ...inputs?.comparisons[comp],
                favoriteStation:
                  inputs?.comparisons[comp]?.favoriteStation?._id,
                difference: differenceValue,
              },
            ]
          }
          return null
        })
        .filter((entry) => entry !== null),
    )

    const resp = await OwnFuelStationsService.update({
      id,
      body: { comparisons: data },
    })
    if (resp) {
      updateInputs({ comparisons: resp?.resp?.comparisons })
    }
  }

  const headerOptions = {
    title: msg({ id: 'competences' }),
    handlerHeaderActions: {
      showBackButton: true,
      secondaryButton:
        isEdit && canEdit(MODULES.FUELSTATIONS, GROUPS.OWN) && handleUpdate,
      secondaryButtonText: 'button.save',
      secondaryButtonIcon: 'pi-save',
      primaryButton:
        !isEdit && canEdit(MODULES.FUELSTATIONS, GROUPS.OWN) && enableEdit,
      primaryButtonText: 'button.enable.edit',
      primaryButtonIcon: 'pi-pencil',
    },
  }

  const data = (
    <div className="boxContainer">
      {/* Comparaciones */}
      <FuelStationComparisionItem
        comparison="comparison1"
        inputs={inputs?.comparisons?.comparison1}
        favoriteStations={favoriteStations}
        onHandleChange={onChangeInputs}
        isOnlyInfo={!isEdit}
      />
      <FuelStationComparisionItem
        comparison="comparison2"
        inputs={inputs?.comparisons?.comparison2}
        favoriteStations={favoriteStations}
        onHandleChange={onChangeInputs}
        isOnlyInfo={!isEdit}
      />
      <FuelStationComparisionItem
        comparison="comparison3"
        inputs={inputs?.comparisons?.comparison3}
        favoriteStations={favoriteStations}
        onHandleChange={onChangeInputs}
        isOnlyInfo={!isEdit}
      />
    </div>
  )

  return (
    <div className="own-competencies">
      <MainCommonView headerOptions={headerOptions} componentData={data} />
    </div>
  )
}

export default OwnFuelStationCompetencies
